// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"2d0f0f91","122":"724e0a76","237":"1bd4044f","352":"369e69bf","480":"e4385727","500":"45606570","577":"79f1d711","655":"1129dacf","744":"f22a1799","866":"056970dc","903":"d2315652"}[chunkId] + ".chunk.js";
};